export enum DYNAMIC_DIALOG_CONFIG {
    STATIC = `{
        "draggable": false,
        "resizable": true,
        "maximizable": true,
        "keepInViewport": true,
        "duplicate": false,
        "modal": true,
        "contentStyle": { "overflow": "auto" }
      }`,
    DRAGGABLE = `{
        "draggable": true,
        "resizable": true,
        "maximizable": true,
        "keepInViewport": true,
        "duplicate": false,
        "modal": false,
        "contentStyle": { "overflow": "auto" }
      }`
  }
